import { useEffect } from "react";
import { fetchAuthSession } from "aws-amplify/auth";
import { useSetRecoilState } from "recoil";
import {
  authTokenState,
  authLoadingState,
  cognitoIdState
} from "features/auth/state/authAtoms";

export const useFetchAuthToken = () => {
  const setAuthToken = useSetRecoilState(authTokenState);
  const setCognitoId = useSetRecoilState(cognitoIdState);
  const setAuthLoading = useSetRecoilState(authLoadingState);

  useEffect(() => {
    let cancelled = false;

    // Playwright E2E バイパス: Cognito を呼ばずに固定トークンを入れる
    if (process.env.REACT_APP_E2E === 'true') {
      setAuthToken('e2e-token');
      setCognitoId('e2e-user');
      setAuthLoading(false);
      return;
    }

    const loadSession = async () => {
      setAuthLoading(true);
      try {
        const session = await fetchAuthSession();
        if (!session || cancelled) {
          if (!cancelled) alert('No auth token found');
          return;
        }

        if (session.tokens?.idToken) {
          setAuthToken(session.tokens.idToken.toString());
        }

        if (session.userSub) {
          setCognitoId(session.userSub.toString());
        }
      } catch (error) {
        if (!cancelled) alert('Error fetching auth session:' + error);
      } finally {
        if (!cancelled) setAuthLoading(false);
      }
    };

    loadSession();
    return () => { cancelled = true; };
  }, [setAuthToken, setCognitoId, setAuthLoading]);
};
